import React from "react";
import { PremisesDashboard } from "../premises";
import PageTitleSection from "./PageTitleSection";

export const PremisesByProject: React.FC = () => (
  <PremisesDashboard
    pageTitleSection={<PageTitleSection />}
    data-id="premisesByProjectDashboard"
  />
);
